import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  viewBox: "0 0 25 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M10.1 4c.31 0 .612.047.897.137A1 1 0 0 1 11.5 4h3.898a4 4 0 0 1 3.76 2.633l1.076 2.96A3 3 0 0 1 22.5 12.5V15a3 3 0 0 1-2.006 2.827q.005.086.006.173a3 3 0 1 1-6 0h-4a3 3 0 1 1-5.995-.173A3 3 0 0 1 2.5 15v-1a1 1 0 1 1 2 0v1a1 1 0 0 0 .79.977A2.99 2.99 0 0 1 9.73 16h5.538a2.99 2.99 0 0 1 4.441-.023A1 1 0 0 0 20.5 15v-2.5a1 1 0 0 0-1-1h-5.3a2 2 0 0 1-1.879-1.316l-.236-.65-.004-.009-1.042-2.867A1 1 0 0 0 10.1 6H3.5a1 1 0 0 1 0-2zM7.5 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2m10 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-11-7a1 1 0 1 1 0 2h-3a1 1 0 1 1 0-2zm7.46-1.158a1 1 0 0 0 .94.658h3.172l-.794-2.184A2 2 0 0 0 15.398 6h-2.47zM8.5 7a1 1 0 0 1 0 2h-5a1 1 0 0 1 0-2z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }